import {ValueObject} from '@s-ui/domain'

export class TrackingPhoneRequestParamsDealerValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {string} data.adId
   * @param {string} data.contractId
   * @param {string} data.url
   * @param {string} data.referrer
   * @param {string} data.adobeMarketingCloudVisitorId
   * @param {string} data.adobeAccount
   * @param {string} data.adobeTrackingServer
   * @param {string} data.adobeVersion
   * @param {string} data.sessionId
   * @param {string} data.pageType
   * @param {string} data.filteredProvinces
   * */

  /**
   * Validation method
   */
  static validate({adId, contractId, errorFactory}) {
    if (!adId && !contractId) errorFactory('Tracking phone needs an ad ID')
  }

  isAdTrackingPhone() {
    return Boolean(this._adId)
  }

  getRequestParams() {
    const isAdTrackingPhone = this.isAdTrackingPhone
    const params = {
      url: this._url,
      referrer: this._referrer,
      adobeMarketingCloudVisitorId: this._adobeMarketingCloudVisitorId,
      adobeAccount: this._adobeAccount,
      adobeTrackingServer: this._adobeTrackingServer,
      adobeVersion: this._adobeVersion,
      sessionId: this._sessionId,
      pageType: this._pageType,
      filteredProvinces: this._filteredProvinces
    }

    return {
      ...params,
      ...(isAdTrackingPhone && {adId: this._adId})
    }
  }

  getContractId() {
    return this._contractId
  }
}
